export default "__VITE_ASSET__Q_RofNYy__"